import { Button } from '@/components/ds2'
import { formatUsd } from './format'

interface InvoiceApprovalProps {
    /** The loads the invoices are for, by number, in the order they are sent. */
    loadNumbers: string[]
    /** Their total, or null when an amount is unknown. */
    total: number | null
    onCreate: () => void
    onCancel: () => void
}

/**
 * The approval area an invoice action opens inside its own block (design §6, §9): the count, the total and the loads, and "Create invoice"
 * as the only send. The Ready list, one load's Invoice, "Invoice all" and the load list all open this, so nothing is sent unconfirmed.
 */
export const InvoiceApproval = ({ loadNumbers, total, onCreate, onCancel }: InvoiceApprovalProps) => {
    const plural = loadNumbers.length === 1 ? '' : 's'
    return (
        <div role="region" aria-label="Approve invoices" className="flex flex-col gap-2 rounded-2xl bg-surface-secondary p-3 text-xs shadow-surface">
            <span className="font-medium">
                Create {loadNumbers.length} invoice{plural} · {formatUsd(total)}
            </span>
            <span className="text-foreground-muted">{loadNumbers.map((number) => `#${number}`).join(', ')}</span>
            <div className="flex items-center gap-2">
                <Button size="sm" onClick={onCreate}>
                    Create invoice{plural}
                </Button>
                <Button size="sm" variant="ghost" onClick={onCancel}>
                    Cancel
                </Button>
            </div>
        </div>
    )
}
